import React, { useState } from 'react';
import { observer } from "mobx-react-lite";
import useStore from "../../../../../hooks/useStore";
import { PlaygroundTabs as TabTypes } from "../../../../../utils/enums";
import ChatBox from "../../../../../elements/ChatBox/ChatBox";
import BasicConfigurationTab from './BasicConfigurationTab';
import AdvancedConfigurationTab from './AdvancedConfigurationTab';
import Spinner from '../../../../../components/common/Spinner';
import {
  Tab,
  TabsContainer,
  TabsHeader,
  TabContent,
  TabElement,
  TabsWrapper
} from '../../../../../elements/v2/Tabs/PlaygroundTabs.styled';
import { useMediaQuery } from 'react-responsive';
import { useUserCheckPermissions } from '../../../../../hooks/useUserCheckPermissions';
import { PermissionCodes, PermissionLevels } from '../../../../../utils/enums';

const PlaygroundTabs = observer(({ toggleChat, isChatVisible, onTabChange }) => {
  const { authStore, editAgent } = useStore();
  const [activeTab, setActiveTab] = useState(0);
  const isMobile = useMediaQuery({ maxWidth: 791 });
  const { checkPermission} = useUserCheckPermissions();

  const handleTabClick = (index) => {
    setActiveTab(index);
    onTabChange(index);
  };

  const handleMetadata = (object) => {
    const k = Object.keys(object).pop()
    const v = Object.values(object).pop()
    editAgent.updateFromConversation(k, v)
    editAgent.setAgentConfigureMetadata()
  }
  const tabs = [
    {
      label: TabTypes.CREATE.label,
      content: (
        <ChatBox
          customerSelected={authStore.selectedAccount?.id}
          agentId={editAgent.agentCreator?.id}
          agentDomain={'creator'}
          inputWidth="80vh"
          metadata={editAgent.agentConfigureMetadata}
          initialMessage={'Hello'}
          handleMetadata={handleMetadata}
          agentData={{
            ...editAgent.agentCreator,
            actions: editAgent.actions,
            placeholderInput: editAgent.agentCreator?.placeholderInput || "Ask anything..."
          }}
        /> 
      ),
    },
    {
      label: TabTypes.BASIC.label,
      content: (
          <BasicConfigurationTab/>
      ),
    },
    {
      label: TabTypes.ADVANCED.label,
      content: (
          <AdvancedConfigurationTab/>
      ),
    },
  ];

  return editAgent.finishedInitialLoad ? (
    <>
      <TabsContainer>
        <TabsHeader>
          <TabsWrapper>
            <Tab
              isActive={activeTab === TabTypes.CREATE.id}
              onClick={() => handleTabClick(TabTypes.CREATE.id)}
            >
              {TabTypes.CREATE.label}
            </Tab>
            {checkPermission(PermissionCodes.PLAYGROUND_BASIC, PermissionLevels.VIEW) && (
              <Tab
                isActive={activeTab === TabTypes.BASIC.id}
                onClick={() => handleTabClick(TabTypes.BASIC.id)}
              >
                {TabTypes.BASIC.label}
              </Tab>
            )} 
            {checkPermission(PermissionCodes.PLAYGROUND_ADVANCED, PermissionLevels.VIEW) && (
              <Tab
                isActive={activeTab === TabTypes.ADVANCED.id}
                onClick={() => handleTabClick(TabTypes.ADVANCED.id)}
              >
                {TabTypes.ADVANCED.label}
              </Tab>
            )}
            {isMobile && (
              <Tab onClick={toggleChat}>
                {isChatVisible ? "Hide Chat" : "Preview"}
              </Tab>
            )}
          </TabsWrapper>
        </TabsHeader>
        <TabContent>
          <TabElement $isActive={activeTab === TabTypes.CREATE.id}>
            {tabs[0].content}
          </TabElement>
          <TabElement $isActive={activeTab === TabTypes.BASIC.id}>
            {tabs[1].content}
          </TabElement>
          <TabElement $isActive={activeTab === TabTypes.ADVANCED.id}>
            {tabs[2].content}
          </TabElement>
        </TabContent>
      </TabsContainer>
    </>
  ) : (
    <Spinner />
  );
});

export default PlaygroundTabs;
